import { Component, OnInit, Input, ElementRef, HostListener, ViewEncapsulation, OnDestroy, HostBinding, ViewChild,ChangeDetectorRef,ChangeDetectionStrategy } from '@angular/core';
import { EventInteraction } from 'angular-engine/engine/service/dynamic/event.interaction.service';
import { VgAPI, VgFullscreenAPI, VgControlsHidden, VgStates } from 'videogular2/core';
import { Observable } from 'rxjs';
import { Subscription } from 'rxjs/Subscription';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
    selector: 'vg-social-links',
    encapsulation: ViewEncapsulation.None,
    template: `<social-icons [isVideo]="true" class="video" [item]="meta" [media]="media"></social-icons>`,
    styles: [``],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class VgSocialLinks implements OnInit, OnDestroy {
    @Input() vgFor: string;
    @Input() config: any;
    @Input() sitetitle: string;
    @Input() isClient: boolean;
    @Input() meta: any;
    @Input() media: any;
    
    private elem: HTMLElement;
    private target: any;
    private subscriptions: any[] = [];
    private isPlaying: boolean;
    private isActive: boolean;
    private isPaused: boolean;
 
  

    @HostBinding('class.is-fullscreen') isFullscreen: boolean = false;

    constructor(ref: ElementRef,
         public API: VgAPI,
         public fsAPI: VgFullscreenAPI,
         private controlsHidden: VgControlsHidden,
         private interactions: EventInteraction,
         private cd : ChangeDetectorRef) {
         this.elem = ref.nativeElement;
    }

    ngOnInit() {
        if (this.API.isPlayerReady) {
            this.onPlayerReady();
        }
        else {
            this.subscriptions.push(this.API.playerReadyEvent.subscribe(() => this.onPlayerReady()));
        }

        this.subscriptions.push(this.interactions.subscribe((event) => {
            if(event.key == "toggleVideoEmbedShare"){
                if (this.getState() === VgStates.VG_PLAYING) {
                    this.target.pause();
                    
                }
            }
// 
//             if(event.key == "triggerVideoEmbedShare"){
//                 this.interactions.next({ key: "toggleVideoEmbedShare", message: { slug: this.meta.slug, media: this.media}})
//             }
        }));

        this.cd.detectChanges();
    }

    onPlayerReady() {
        this.target = this.API.getMediaById(this.vgFor);
        this.media = this.API.getDefaultMedia();
        this.subscriptions.push(this.fsAPI.onChangeFullscreen.subscribe(this.onChangeFullscreen.bind(this)));
        this.subscriptions.push(this.media.subscriptions.playing.subscribe(this.onPlaying.bind(this)));
        this.subscriptions.push(this.media.subscriptions.ended.subscribe(this.onPlaying.bind(this)));
        this.subscriptions.push(this.media.subscriptions.pause.subscribe(this.onPause.bind(this)));
        this.cd.detectChanges();
    }

    onChangeFullscreen(fsState: boolean) {
        this.isFullscreen = fsState;
    }

    onPlaying(state) {
        if (this.isActive) {
            this.isPlaying = this.API.state === "playing";
            if (this.isPaused) {
                //unpausing video while bar opened, close bar
                this.isPaused = false
                this.isActive = false
            }
        }
    }

    onPause(state) {
        this.isPaused = this.API.state === "paused";
    }

    getState() {
        return this.target ? this.target.state : VgStates.VG_PAUSED;
    }

    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach(s => s.unsubscribe());
        }
        delete this.elem;
    }
}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/video-player/controls/vg-social-links.component.ts